import { render, staticRenderFns } from "./DiasVencimiento.vue?vue&type=template&id=0a3af7e0"
import script from "./DiasVencimiento.vue?vue&type=script&lang=js"
export * from "./DiasVencimiento.vue?vue&type=script&lang=js"
import style0 from "./DiasVencimiento.vue?vue&type=style&index=0&id=0a3af7e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports